var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error center-align"},[_c('h1',{staticClass:"fl"},[_vm._v("ERROR 404!")]),_vm._v(" "),_c('h5',[_c('router-link',{staticClass:"red-text",attrs:{"to":"/"}},[_vm._v("← Go back home")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2583a6ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/404.vue
// module id = null
// module chunks = 